export default "__VITE_ASSET__bdce8be1__"